import { createContext, useContext, useEffect, useState } from "react";
import api from "../lib/api";

const AuthContext = createContext(null);

export const useAuth = () => useContext(AuthContext);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = checking, false = anon
  const [ready, setReady] = useState(false);
  const [impersonating, setImpersonating] = useState(localStorage.getItem("impersonating") || null);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get("/auth/me");
        setUser(data);
      } catch (e) {
        if (e?.response?.status && e.response.status !== 401)
          console.error("Auth check failed:", e);
        setUser(false);
      } finally {
        setReady(true);
      }
    })();
  }, []);

  const login = async (email, password) => {
    await api.post("/auth/login", { email, password });
    const me = await api.get("/auth/me");
    setUser(me.data);
    return me.data;
  };

  const register = async (email, password, name) => {
    await api.post("/auth/register", { email, password, name });
    const me = await api.get("/auth/me");
    setUser(me.data);
    return me.data;
  };

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch (e) { console.error("Logout request failed:", e); }
    localStorage.removeItem("impersonating");
    setImpersonating(null);
    setUser(false);
  };

  const refresh = async () => {
    try { const { data } = await api.get("/auth/me"); setUser(data); }
    catch (e) { console.error("Failed to refresh user:", e); }
  };

  const impersonate = async (companyId) => {
    const { data } = await api.post(`/companies/${companyId}/impersonate`);
    localStorage.setItem("impersonating", data.company_name || "azienda");
    setImpersonating(data.company_name || "azienda");
    const me = await api.get("/auth/me");
    setUser(me.data);
    return me.data;
  };

  const stopImpersonate = async () => {
    await api.post("/company/stop-impersonate");
    localStorage.removeItem("impersonating");
    setImpersonating(null);
    const me = await api.get("/auth/me");
    setUser(me.data);
    return me.data;
  };

  return (
    <AuthContext.Provider value={{ user, ready, login, register, logout, refresh, impersonating, impersonate, stopImpersonate }}>
      {children}
    </AuthContext.Provider>
  );
}
